import {
	salesUser, manageCategory, manageSubCategory, manageLocation, manageFare, manageCancelReasons
} from '../helpers/demoRestriction/demo';
import showToaster from '../helpers/toastrMessgaes/showToaster';

export function demoRestriction({ restrictType = null, restrictValue = null }) {
	return async (dispatch, getState, { client }) => {
		try {
			const adminId = getState()?.account?.id;
			const isDemoRestricted = getState()?.siteSettings?.data?.isDemoRestricted;
			if (isDemoRestricted == "true") {
				switch (restrictType) {
					case 'category':
						if (salesUser.indexOf(adminId) < 0 && manageCategory.indexOf(restrictValue) > -1) {
							showToaster({ messageId: 'demoWarning', toasterType: 'warning' });
							return true;
						} else return false;

					case 'subCategory':
						if (salesUser.indexOf(adminId) < 0 && manageSubCategory.indexOf(restrictValue) > -1) {
							showToaster({ messageId: 'demoWarning', toasterType: 'warning' });
							return true;
						} else return false;

					case 'location':
						if (salesUser.indexOf(adminId) < 0 && manageLocation.indexOf(restrictValue) > -1) {
							showToaster({ messageId: 'demoWarning', toasterType: 'warning' });
							return true;
						} else return false;

						case 'cancelReason':
						if (salesUser.indexOf(adminId) < 0 && manageCancelReasons.indexOf(restrictValue) > -1) {
							showToaster({ messageId: 'demoWarning', toasterType: 'warning' });
							return true;
						} else return false;

					case 'fare':
						if (salesUser.indexOf(adminId) < 0 && manageFare.indexOf(restrictValue) > -1) {
							showToaster({ messageId: 'demoWarning', toasterType: 'warning' });
							return true;
						} else return false;

					default:
						if (salesUser.indexOf(adminId) < 0) {
							showToaster({ messageId: 'demoWarning', toasterType: 'warning' });
							return true;
						} else return false;
				}
			} else {
				return false;
			}
		} catch (error) {
			return false;
		}
	};
}

export function demoRestrictionEncode({ restrictType = null, restrictValue = null }) {
	return async (dispatch, getState, { client }) => {
		try {
			const isDemoRestricted = getState()?.siteSettings?.data?.isDemoRestricted;
			const adminId = getState()?.account?.id;
			if (isDemoRestricted == "true") {
				switch (restrictType) {
					default:
						if (salesUser.indexOf(adminId) < 0) {
							return true;
						} else return false;
				}
			} else {
				return false;
			}
		} catch (error) {
			return false;
		}
	};
}